export enum DashboardRoutes {
  Default = "pulse"
};
